export default "__VITE_ASSET__D$SnohCN__"